import './index.erb';
import './index.rb';
import './index.scss';
import 'components/applied_test';

(function ($) {
  'use strict';

  const $lastExams = $('.last-exam');
  const $btnViewMoreExams = $('#more-exams');
  const $btnViewLessExams = $('#less-exams');
  $btnViewMoreExams.click(() => {
    $btnViewMoreExams.hide();
    $lastExams.show();
  });

  $btnViewLessExams.click(() => {
    $lastExams.hide();
    $btnViewMoreExams.show();
  });
})(jQuery);
